import axios from 'axios'
import store from '../store'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchSessionId({ state }, payload) {
    // let url = `${appConfig.apiEndPoint}${endpoint.VoAReport.voaOrderReport}`
    let url = `https://websrviqa.wm.cashedge.com/WealthManagementWeb/ws/UserMgmt/signon`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchWidgets({ state }, payload) {
    let url = `https://aggqa.alldata.cashedge.com/PFM_UI/widgets/base/addaccounts/addAccountsWidget.iface?sessionToken=${payload}&return_url=www.google.com`
    return axios
      .post(url, '', {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
